export default ({ text }) => {
  return <div className="text-dias-semanas">{text}</div>;
};
